import React from 'react';
import { useGetBankAccountsQuery } from '../../BankAccounts/Service/bankAccountsApi';
import { useGetBankAccountsForCompanyQuery } from '../../BankAccounts/Service/extendedBankAccountsApi';
import {
  mapBankAccountToInvoiceLookup,
  type InvoiceBankAccountLookup,
} from './bankAccountsLookupMapper';

export const useGetInvoiceBankAccountsLookupQuery = () => {
  const queryResult = useGetBankAccountsQuery();

  const data = React.useMemo(
    () =>
      (queryResult.data ?? [])
        .map((account) => mapBankAccountToInvoiceLookup(account as any))
        .filter((account): account is InvoiceBankAccountLookup => Boolean(account)),
    [queryResult.data]
  );

  return {
    ...queryResult,
    data,
  };
};

export const useGetInvoiceBankAccountsForCompanyLookupQuery = (
  companyId: number,
  options?: { skip?: boolean }
) => {
  const queryResult = useGetBankAccountsForCompanyQuery(companyId, options as any);

  const data = React.useMemo(
    () =>
      (queryResult.data ?? [])
        .map((account) => mapBankAccountToInvoiceLookup(account as any))
        .filter((account): account is InvoiceBankAccountLookup => Boolean(account)),
    [queryResult.data]
  );

  return {
    ...queryResult,
    data,
  };
};
